// extracted by mini-css-extract-plugin
export default {"container":"loading-message_container__Rjy+x"};